export {
  DeckProficiencyTag,
  DeckProficiencyTagProps,
} from './DeckProficiencyTag';
